import MuiIcon, { IconProps } from "@material-ui/core/Icon";
import * as React from "react";

type Props = IconProps & {
  className?: string;
  name: string;
};

type State = {};

class Icon extends React.Component<Props, State> {
  render() {
    const { className, name } = this.props;
    return (
      <MuiIcon {...this.props} className={className}>
        {name}
      </MuiIcon>
    );
  }
}

export { Icon };
